import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { MoreHoriz } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import HierarchyActionsMenu from './HierarchyActionsMenu';

const HierarchyActionsButton = ({ hierarchy, hierarchyActions, events }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  const handleClick = event => {
    setMenuAnchorEl(event.target);
  };

  return (
    <>
      <IconButton
        aria-controls='hierarchy-actions-menu'
        id={`asset-hierarchy-${hierarchy.id}-actions`}
        size='tiny'
        variant='text'
        color='primary'
        tooltip={t('General.Actions')}
        disabled={events.onDisableHierarchy(hierarchy)}
        onClick={handleClick}
      >
        <MoreHoriz fontSize='small' />
      </IconButton>
      <HierarchyActionsMenu hierarchy={hierarchy} hierarchyActions={hierarchyActions} anchorEl={menuAnchorEl} onClose={handleClose} />
    </>
  );
};

HierarchyActionsButton.propTypes = {
  hierarchy: PropTypes.object.isRequired,
  hierarchyActions: PropTypes.array.isRequired,
  events: PropTypes.object.isRequired
};

export default HierarchyActionsButton;
